import {
    BLOCK_FAMILIAR,
    BLOCK_FAMILIAR_SUCCESS,
    BLOCK_FAMILIAR_ERROR
} from "../constants/familiarConstant";


const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};


function familiarReducer(state = initialState, action) {

    switch (action.type) {
        case BLOCK_FAMILIAR:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': ''
            });
        case BLOCK_FAMILIAR_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case BLOCK_FAMILIAR_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': ''
            });
        default:
            return state;
    }
};

export default familiarReducer